var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
/**
 * @hidden
 */

var MiddleLayerOptimization = function (_super) {
  __extends(MiddleLayerOptimization, _super);

  function MiddleLayerOptimization() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MiddleLayerOptimization.prototype.shouldComponentUpdate = function (nextProps) {
    return nextProps.shouldUpdateOnDrag || !nextProps.isDragging;
  };

  MiddleLayerOptimization.prototype.render = function () {
    return this.props.children;
  };

  return MiddleLayerOptimization;
}(React.Component);

export { MiddleLayerOptimization };